import { atom } from "recoil";
import { sessionStorageEffect } from "./persistAtom";

export const userState = atom({
  key: "userState",
  default: null,
  effects: [sessionStorageEffect("user")],
});

export const authLoadingState = atom({
  key: "authLoadingState",
  default: false,
});

export const authErrorState = atom({
  key: "authErrorState",
  default: null,
});

// 사용자 정보 로딩 완료 상태
export const userInfoLoadedState = atom({
  key: "userInfoLoadedState",
  default: false,
});
